<template>
  <div class="JobsTitleAndDescription">
    <div class="content flex-jc-bt flex-no-wrap">
      <div class="flex-85 left-side">
        <sp-card type="none" custom-class="sp-color-bg-4">
          <div class="card-content">
            <div class="flex flex-al-center pd-b-20">
              <!--              <div class="flex-10"> -->
              <!--                <sp-button -->
              <!--                  to="addResponsibilities" -->
              <!--                  class="bt-item" -->
              <!--                  :width="100" -->
              <!--                  :height="44" -->
              <!--                  circle-radius="22" -->
              <!--                  type="warn" -->
              <!--                  :bold="400" -->
              <!--                  :font="18" -->
              <!--                  :label="$l('AddMore')" -->
              <!--                /> -->
              <!--              </div> -->
              <div class="flex-85 flex-jc-bt">
                <div class="flex-al-center">
                  <span class="mg-r-20">
                    {{ $l('DeptAccessIdentity') }}
                  </span>
                  <sp-select v-model="filterForm.identity" type="grayBorder1"
                             height="34" width="230" @after-select="searchProfession">
                    <sp-select-option v-for="(item, key) in deptIdentity" :key="key" :value="key" :label="$L(item.title)" type="primary" />
                  </sp-select>
                </div>
                <div class="flex-al-center">
                  <span class="mg-r-20">
                    {{ $l('Responsibilities') }}
                  </span>
                  <sp-select v-model="filterForm.professionId" type="grayBorder1"
                             height="34" width="230" @after-select="searchPosition">
                    <sp-select-option v-for="pro in professionOptions" :key="pro.id" :value="pro.id" :label="pro.name" type="primary" />
                  </sp-select>
                </div>
                <div class="flex-al-center">
                  <span class="mg-r-20">
                    {{ $l('Position') }}
                  </span>
                  <sp-select v-model="filterForm.positionId" type="grayBorder1"
                             height="34" width="230" @after-select="searchPosition">
                    <sp-select-option v-for="pro in positionOptions" :key="pro.id" :value="pro.id" :label="pro.name" type="primary" />
                  </sp-select>
                </div>
                <div class="flex-al-center">
                  <sp-button :width="100" :height="40" circle-radius="10" type="primary" :bold="400" :font="18" :label="$L('Search')" @click="getListing" />
                </div>
              </div>
            </div>
            <SpTableDIY v-model:currPage="currPage" :data-list="dataList" :total="total" column-height="80" :page-size="pageSize">
              <SpTableColumn column-name="serialNo" label="SrialNo" />
              <SpTableColumn column-name="AccessIdentity" width="200" label="AccessIdentity">
                <template #default="row">
                  {{ $l(deptIdentity[row.identity]?.title) }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Responsibilities" width="200" label="Responsibilities">
                <template #default="row">
                  {{ row.profession?.name }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Position" label="Position">
                <template #default="row">
                  {{ row.position?.name }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="description" label="JobDescription">
                <template #default="row">
                  <el-popover placement="bottom"
                              :width="388"
                              trigger="hover">
                    {{ row.description }}
                    <template #reference>
                      <p class="ellipsis-3 label text-center">
                        {{ row.description }}
                      </p>
                    </template>
                  </el-popover>
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Permission" label="Permission">
                <template #default="row">
                  <sp-icon class="pointer" type="search" @click="goPermissions(row, 'readonly')" />
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Action" width="80">
                <template #default="row">
                  <div class="flex-jc-ard">
                    <!--                    <sp-icon class="pointer" :class="{disabledIcon: row.creatorId === userId}" :disabled="row.creatorId === userId" type="edit" @click="goEdit(row)" /> -->
                    <!--                    <sp-icon class="pointer" type="heart" :class="{disabledIcon: row.creatorId === userId}" @click="collection(row)" /> -->

                    <span v-if="row.employerId !== userId && !row.owned"
                          class="icon-heart iconfont pointer-no sp-color-7" style="font-size: 22px; "
                          @click="collection(row, row.$index)" />
                    <span v-if="row.employerId !== userId && row.owned"
                          class="icon-heart iconfont pointer-no sp-color-7" style="font-size: 22px; color: red" />
                  </div>
                </template>
              </SpTableColumn>
            </SpTableDIY>
          </div>
        </sp-card>
      </div>
      <div class="flex-13">
        <spButton circle bold type="back" :width="211" :height="75" class="float-r" style="position:relative; top: 16px">
          <span class="font-bold font18">{{ $l('Back') }}</span>
        </spButton>
        <div class="right-side sp-color-bg-4">
          <SpTableDIY :data-list="dataList" column-height="80">
            <SpTableColumn column-name="EnteredBy" label="EnteredBy">
              <template #default="row">
                <div>{{ row.creatorCorpName }}</div>
                <div>{{ row.creatorName }}</div>
                <div class="attach">
                  {{ getDateToFormatEn(row.sourceCreatedAt) }}
                </div>
              </template>
            </SpTableColumn>
          </SpTableDIY>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import spCard from '@/components/common/SpCard'
import spButton from '@/components/common/SpButton'
import spIcon from '@/components/common/SpIcon'
import spSelect from '@/components/common/SpSelect'
import spSelectOption from '@/components/common/SpSelectOption'
import spPopover from '@/components/common/SpPopover'
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import SpTableDIY from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'
import spInput from '@/components/common/SpInput'
import {
  enterpriseJobCopyApi,
  getEnterpriseJobSearchApi,
  getOptionsJobPositionApi,
  getOptionsJobProfessionApi,
  getPermissionTreeApi
} from '@/request/APIs/company'
import { DEPT_IDENTITY } from '@/config/company'
import { getDateToFormatEn } from '@/utils/convert'
import SpMessage from '@/components/common/SpMessage'
export default {
  name: 'JobsCollection',
  nameSpace: 'company.JobsCollection',
  components: {
    spCard,
    spButton,
    spIcon,
    spPopover,
    spSelect,
    spSelectOption,
    spTag,
    spTagGroup,
    SpTableDIY,
    SpTableColumn,
    spInput
  },

  data () {
    return {
      filterForm: {},
      professionOptions: [],
      positionOptions: [],
      dataList: [],
      currPage: 1,
      total: 0,
      pageSize: 0,
      deptIdentity: DEPT_IDENTITY,
      getDateToFormatEn
    }
  },

  computed: {
    userId () {
      return this.$store.state.user.user.id
    }

  },

  watch: {
    currPage (n) {
      this.getListing()
    }
  },

  created () {
    this.getListing()
  },

  mounted () {
  },

  methods: {

    // 获取职务选项 和 权限结构
    searchProfession (identity) {
      getOptionsJobProfessionApi(identity, 1).then(res => {
        this.professionOptions = res.data
      })
    },

    // 获取职位选项
    searchPosition (profession) {
      getOptionsJobPositionApi(profession, 1).then(res => {
        this.positionOptions = res.data
      })
    },

    goEdit (row) {
      if (row.creatorId === this.userId) return
      this.$router.push({
        name: 'addResponsibilities',
        query: {
          type: 'copy',
          id: row.id
        }
      })
    },

    // 收藏
    collection (row) {
      if (row.creatorId === this.userId) return
      enterpriseJobCopyApi(row.id).then(res => {
        if (res.code === 1) {
          SpMessage({
            message: res.message,
            type: 'success'
          })
        }
      })
    },

    getListing () {
      getEnterpriseJobSearchApi({ ...this.filterForm, page: this.currPage }).then(res => {
        this.dataList = res.data.data
        this.total = res.data.total
        this.pageSize = res.data.pageSize
      })
    },

    goPermissions (row, readonly) {
      const query = {
        id: row.id
      }
      if (readonly) {
        query.readonly = true
      }
      this.$router.push({
        name: 'permissionsSetting',
        query
      })
    }
  }
}
</script>

<style scoped lang="less">
.JobsTitleAndDescription {
    .content {
        padding: @gap*2 @gap @gap @gap;
        .left-side {
            .card-content {
                padding: @gap;
                .bt-item {
                padding: 0 @gap / 2;
            }
            .tags {
                margin-top: @gap;
            }
            }
        }
        .right-side {
            padding: 20px @gap @gap @gap;
            margin: 100px 0 0 0 ;
        }
    }
    .attach {
        color: #676767;
        font-size: 14px;
    }
  .disabledIcon{
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>
